import { z } from 'zod';
import { Address, AddressSchema, BaseEntity, Identification, IdentificationSchema, WithBaseEntitySchema } from '@40seas/models';
import { EnumSchema, Executor, FromSchema, ZodDate } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { InsuranceProvider } from '../insurance';
import { BusinessMatch, BusinessMatchSchema } from '@40seas/entities/match';

export const InsuranceCompanySchema = WithBaseEntitySchema(
    z.object({
        buyer: z.string(),
        provider: z.string(),
        grade: z.string().optional(),
        legalName: z.string(),
        address: AddressSchema,
        dba: z.array(z.string()).optional(),
        phone: z.string().optional(),
        identification: z.array(IdentificationSchema).optional(),
        businessStartDate: ZodDate.optional(),
        score: z.number().optional(),
        companyId: z.string().optional(),
        match: BusinessMatchSchema,
    }),
).strict();

export class InsuranceCompany extends FromSchema(InsuranceCompanySchema) implements BaseEntity {
    id: string;
    buyer: string;
    provider: InsuranceProvider | string;

    grade?: string;
    legalName: string;
    address: Address;
    dba?: string[];
    phone?: string;
    identification?: Identification[];
    businessStartDate?: Date;
    score?: number;
    companyId?: string;
    match: BusinessMatch;

    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
